// extracted by mini-css-extract-plugin
export var drawerPaper = "_1r-0";
export var itemImage = "_1r-1";